<template lang="pug">
div
  b-form(@submit.stop.prevent="onSubmit")
    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 fingerprint
          b-form-group(label="ID")
            b-form-input.input(v-model="form.id" readonly)
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 pin
          b-form-group(label="Código")
            b-form-input.input(v-model="form.drivInCode")

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 perm_identity
          b-form-group(label="Destinatario")
            b-form-input.input(v-model="form.finalCustomer" maxlength="150")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 phone
          b-form-group(label="Teléfono")
            b-form-input.input(v-model="form.contactPhone" @update="cleanPhoneOnUpdate(form)")

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 email
          b-form-group(label="Email")
            b-form-input.input(v-model="form.contactEmail")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 local_shipping
          b-form-group(label="Conductor")
            v-select(
              v-model="driverSelected"
              :options="driverOptions"
              label="text"
              placeholder="Selecciona un Conductor"
              :clearable="true"
              @input="onChangeDriver"
            )
              span(slot="no-options") Lo siento, no se pudo encontrar el conductor

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 store
          b-form-group(label="Tienda")
            v-select(
              v-model="storeSelected"
              :options="storeOptions"
              label="text"
              placeholder="Selecciona una Tienda"
              @option:selected="onChangeStore"
              :clearable="true"
            )
              span(slot="no-options") Lo siento, no se pudo encontrar la tienda
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 calendar_today
          b-form-group(label="Fecha")
            b-form-input.input(v-model="form.date" type="date")

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 place
          b-form-group(label="Comuna")
            b-form-input.input(v-model="form.commune" maxlength="256")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 place
          b-form-group(label="Dirección")
            b-form-input.input(v-model="form.address" maxlength="256")

    .box-form
      .material-icons.icon-input.pr-1 comment
      b-form-group(label="Comentario Interno")
        b-form-textarea.input(v-model="form.internalComment" maxlength="1000")

    .box-form
      .material-icons.icon-input.pr-1 playlist_add_check
      b-form-group(label="Observaciones")
        b-form-textarea.input(v-model="form.observations" maxlength="256" no-resize)

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 sell
          b-form-group(label="Tags")
            b-form-select.input(v-model="form.tags" :options="tagsOptions")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 local_shipping
          b-form-group(label="Estado")
            b-form-select.input(v-model="form.status")
              b-form-select-option(:value="'approved'") Entregado
              b-form-select-option(:value="'in-transit'") En Tránsito
              b-form-select-option(:value="'partial'") Pendiente
              b-form-select-option(:value="'rescheduled'") Reprogramado
              b-form-select-option(:value="'rejected'") Rechazado
              b-form-select-option(:value="'cancelled'") Cancelado

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input face
          b-form-group(label="Persona que Recibe")
            b-form-input.input(v-model="form.receiverName" type="text" placeholder="Ingresa el nombre")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input pin
          b-form-group(label="Rut")
            b-form-input.input(v-model="form.receiverRut" type="text" placeholder="Ingresa el Rut")

    .box-form
      .material-icons.icon-input.pr-1 comment
      b-form-group(label="Comentario de entrega")
        b-form-textarea.input(v-model="form.comment" maxlength="256" no-resize)

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 inventory_2
          b-form-group(label="Cantidad de Bultos")
            b-form-input.input(v-model="form.bundleQuantity" type="number" min="1")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 replay
          b-form-group(label="Cantidad de Intentos")
            b-form-input.input(v-model="form.deliveryAttempts" type="number" min="1")

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 dns
          b-form-group(label="Source System")
            b-form-input.input(v-model="form.sourceSystem")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 tag
          b-form-group(label="External ID")
            b-form-input.input(v-model="form.externalId")

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 switch_access
          b-form-group(label="Es Pickup Request")
            b-form-checkbox(v-model="form.isPickupRequest" switch)
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 calendar_today
          b-form-group(label="Fecha de cierre (deliveredAt)")
            b-form-input.input(v-model="form.deliveredAt" type="datetime-local")

    hr
    h6 Partner

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 local_shipping
          b-form-group(label="Partner (Courier)")
            b-form-select.input(v-model="form.partnerCode")
              b-form-select-option(:value="null") Selecciona un Partner
              b-form-select-option(
                v-for="partner in partnerOptions"
                :key="partner.value"
                :value="partner.value"
              ) {{ partner.text }}
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 confirmation_number
          b-form-group(label="Partner Delivery ID")
            b-form-input.input(v-model="form.partnerDeliveryId")

    b-row
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 info
          b-form-group(label="Partner Delivery Status")
            b-form-input.input(v-model="form.partnerDeliveryStatus")
      b-col(cols="12" md="6")
        .box-form
          .material-icons.icon-input.pr-1 update
          b-form-group(label="Última Sincronización Partner")
            b-form-input.input(v-model="form.lastPartnerSyncAt" type="datetime-local")

    .box-form
      .material-icons.icon-input.pr-1 data_object
      b-form-group(label="Partner Last Sync Data (JSON)")
        div(style="flex: 1;")
          b-form-textarea.input(v-model="form.partnerLastSyncData" placeholder="JSON data o vacío para borrar" rows="3")
          b-button.mt-1(size="sm" variant="outline-danger" @click="form.partnerLastSyncData = ''") Borrar datos

    .box-form
      .material-icons.icon-input.pr-1 error
      b-form-group(label="Error de Sincronización Partner")
        b-form-textarea.input(v-model="form.partnerDeliverySyncError" placeholder="Si está vacío se enviará como null" rows="3")

    .text-right.mt-3
      b-button(type="submit" :disabled="loading" variant="primary") Guardar Debug
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import vSelect from 'vue-select'
import { cleanPhone } from '../../utils/cleanData'
import partnerUtils from '../../utils/partnerUtils'
import { isDriverRole } from '../../constants/userRoles'

export default {
  mixins: [MakeToastMixin],
  props: {
    delivery: {
      type: Object,
      required: true
    }
  },
  components: {
    vSelect
  },
  data() {
    return {
      loading: false,
      storeSelected: null,
      driverSelected: null,
      stores: [],
      form: {
        id: this.delivery.id,
        drivInCode: this.delivery.drivInCode || '',
        finalCustomer: this.delivery.finalCustomer || '',
        contactPhone: this.delivery.contactPhone || '',
        contactEmail: this.delivery.contactEmail || '',
        driverId: null,
        internalComment: this.delivery.internalComment || '',
        partnerCode: this.delivery.partnerCode || null,
        partnerDeliveryId: this.delivery.partnerDeliveryId || '',
        partnerDeliveryStatus: this.delivery.partnerDeliveryStatus || '',
        partnerDeliverySyncError: this.delivery.partnerDeliverySyncError || '',
        partnerLastSyncData: this.delivery.partnerLastSyncData
          ? (typeof this.delivery.partnerLastSyncData === 'object'
            ? JSON.stringify(this.delivery.partnerLastSyncData, null, 2)
            : this.delivery.partnerLastSyncData)
          : '',
        lastPartnerSyncAt: this.delivery.lastPartnerSyncAt || '',
        storeId: this.delivery.storeId || null,
        customerName: this.delivery.customerName || '',
        date: this.$moment(this.delivery.date).format('YYYY-MM-DD'),
        commune: this.delivery.commune || '',
        address: this.delivery.address || '',
        observations: this.delivery.observations || '',
        tags: this.delivery.tags || null,
        status: this.delivery.status || '',
        receiverName: this.delivery.receiverName || '',
        receiverRut: this.delivery.receiverRut || '',
        comment: this.delivery.comment || '',
        bundleQuantity: this.delivery.bundleQuantity ?? 1,
        deliveryAttempts: this.delivery.deliveryAttempts ?? 1,
        sourceSystem: this.delivery.sourceSystem || '',
        externalId: this.delivery.externalId || '',
        isPickupRequest: this.delivery.isPickupRequest || false,
        deliveredAt: this.delivery.deliveredAt
          ? this.$moment(this.delivery.deliveredAt).format('YYYY-MM-DDTHH:mm')
          : ''
      },
      tagsOptions: [
        { text: 'N/A', value: null },
        { text: 'Flex', value: 'flex' },
        { text: 'Cambio', value: 'exchange' },
        { text: 'Devolución', value: 'return' }
      ]
    }
  },
  methods: {
    ...mapActions(['updateDelivery', 'listUser', 'listAllStoreName']),
    cleanPhoneOnUpdate(item) {
      this.$nextTick(() => {
        if (item.contactPhone !== cleanPhone(item.contactPhone)) {
          item.contactPhone = cleanPhone(item.contactPhone)
        }
      })
    },
    onChangeStore(store) {
      if (store) {
        this.form.storeId = store.value
        this.form.customerName = store.text
      } else {
        this.form.storeId = null
        this.form.customerName = ''
      }
    },
    onChangeDriver(driver) {
      this.form.driverId = driver ? driver.value : null
    },
    async onSubmit() {
      this.loading = true
      try {
        if (this.form.partnerDeliverySyncError === '') {
          this.form.partnerDeliverySyncError = null
        }
        if (this.form.partnerLastSyncData === '') {
          this.form.partnerLastSyncData = null
        }
        if (this.form.lastPartnerSyncAt === '') {
          this.form.lastPartnerSyncAt = null
        }
        if (this.form.deliveredAt === '') {
          this.form.deliveredAt = null
        }

        const formData = new FormData()
        for (const key in this.form) {
          if (this.form[key] === null) {
            continue
          }
          formData.append(key, this.form[key])
        }

        const response = await this.updateDelivery({ data: formData, id: this.delivery.id })
        if (response.status === 200) {
          this.makeSuccessToast('Debug: Envío actualizado correctamente')
          this.$emit('done')
        } else if (response.status >= 400) {
          this.makeDangerToast(response.data.message || 'Error al actualizar el envío')
        }
      } catch (error) {
        console.error(error.message)
        this.makeDangerToast('Ocurrió un error al actualizar el envío')
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['users', 'user']),
    partnerOptions() {
      return partnerUtils.partnerSelectOptions
    },
    driverOptions() {
      return this.users
        .filter(user => isDriverRole(user.role))
        .map(user => ({
          value: user.id,
          text: `${user.name} ${user.lastName}`
        }))
    },
    storeOptions() {
      return this.stores.map(store => ({
        value: store.id,
        text: store.name
      }))
    }
  },
  async created() {
    if (this.user.role === 'admin') {
      this.listUser()
      const stores = await this.listAllStoreName()
      this.stores = stores
      if (this.delivery?.storeId) {
        const store = this.stores.find(s => s.id === this.delivery.storeId)
        this.storeSelected = store ? { value: store.id, text: store.name } : null
      }
      if (this.delivery?.driverId) {
        const driver = this.users.find(u => u.id === this.delivery.driverId)
        if (driver) {
          this.driverSelected = { value: driver.id, text: `${driver.name} ${driver.lastName}` }
          this.form.driverId = driver.id
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box-form {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.icon-input {
  padding-top: 32px;
  padding-right: 8px;
  color: #6c757d;
}

.input {
  flex: 1;
}
</style>
